"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SENSOR_STATUS_WARNING = exports.SENSOR_STATUS_OK = exports.SENSOR_STATUS_NODATA = exports.SENSOR_STATUS_MAP = exports.SENSOR_STATUS_CRITICAL = void 0;
var _colors = require("./colors");
var SENSOR_STATUS_NODATA = exports.SENSOR_STATUS_NODATA = 'NODATA';
var SENSOR_STATUS_OK = exports.SENSOR_STATUS_OK = 'OK';
var SENSOR_STATUS_WARNING = exports.SENSOR_STATUS_WARNING = 'WARNING';
var SENSOR_STATUS_CRITICAL = exports.SENSOR_STATUS_CRITICAL = 'CRITICAL';
var SENSOR_STATUS_MAP = exports.SENSOR_STATUS_MAP = [{
  value: SENSOR_STATUS_NODATA,
  color: _colors.SENSOR_NODATA_COLOR
}, {
  value: SENSOR_STATUS_OK,
  color: _colors.SENSOR_OK_COLOR
}, {
  value: SENSOR_STATUS_WARNING,
  color: _colors.SENSOR_WARNING_COLOR
}, {
  value: SENSOR_STATUS_CRITICAL,
  color: _colors.SENSOR_CRITICAL_COLOR
}];